import React from 'react';
import IndustryPageTemplate from '../../components/IndustryPageTemplate';
import SEO from '../../components/SEO';

const MusicLessons = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How can Local Business Heroes help my music lessons business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Local Business Heroes helps music lessons businesses capture more leads, automate follow-ups, reduce no-shows, and grow faster. Rated 4.9/5 by 1,200+ UK businesses."
        }
      },
      {
        "@type": "Question",
        "name": "How much does it cost for music lessons businesses?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Plans start at £297/month with a 14-day trial for just £5. Most music lessons businesses see ROI within the first month."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need technical skills to use it?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Local Business Heroes is designed for busy business owners with zero tech experience. Setup takes 5 minutes with UK-based support."
        }
      },
      {
        "@type": "Question",
        "name": "Will it work for my music lessons business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Local Business Heroes is specifically designed for local service businesses like music lessons. Features include appointment scheduling, automated reminders, lead capture, and customer management."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "CRM for Music Lessons - Local Business Heroes",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "297",
      "priceCurrency": "GBP"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "1200"
    }
  };

  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: "Industries", url: "/industries" },
    { name: "Music Lessons CRM", url: "/industries/music-lessons" }
  ];

  const industryData = {
    name: 'Music Lessons',
    title: 'Fill Your Teaching Schedule & Reduce Student Dropouts',
    subtitle: 'Automate lesson scheduling, send practice reminders, and keep students progressing long-term',
    icon: '🎵',
    challenges: [
      'Last-minute cancellations leave gaps',
      'Students quit after a few months',
      'Hard to get students to practice',
      'Recital coordination is chaotic',
      'Difficult to manage multiple instructors'
    ],
    solutions: [
      'Online booking with cancellation waitlist',
      'Progress milestone celebrations',
      'Practice reminder automation',
      'Recital management system',
      'Multi-instructor scheduling'
    ],
    features: [
      'Student CRM with progress tracking',
      'Online lesson booking',
      'Practice reminders',
      'Progress milestone tracking',
      'Recital coordination',
      'Instructor schedule management',
      'Payment automation',
      'Review requests'
    ],
    results: [
      '70% student retention beyond 1 year',
      'Fill 95% of teaching slots',
      '50% reduction in cancellations',
      '£4.4K average monthly revenue increase'
    ]
  };

  return (
    <>
      <SEO 
        title="CRM for Music Lessons UK | Marketing Automation | Local Business Heroes"
        description="Rated 4.9/5. CRM and marketing automation for music lessons businesses. Capture more leads, automate follow-up, grow faster. Start £5 trial today."
        keywords="CRM for music lessons UK, music lessons business software, music lessons customer management, music lessons lead generation UK"
        url="/industries/music-lessons"
        schemaMarkup={[faqSchema, localBusinessSchema]}
        breadcrumbs={breadcrumbs}
      />
      <IndustryPageTemplate industry={industryData} />
    </>
  );
};

export default MusicLessons;